import React from "react"
import PropTypes from "prop-types"
import { withRouter } from '../../../lib/withRouter'
import { connect } from "react-redux"
import { formatDate, getPath, getViewPatientData } from "../../../lib"
import PatientSidebar from "../../ViewData/PatientSidebar"

export class RecycledLeadTab extends React.Component {
    tableColumns = [
        { key: "Member_CIN", label: "Member_CIN", className: "text-center", style: { width: "15%" } },
        { key: "Lead_Name", label: "Lead_Name", className: "text-left" },
        { key: "Closed_Date", label: "Closed_Date", className: "text-center", style: { width: "10%" } },
    ];

    static propTypes = {
        query: PropTypes.object,
        selection: PropTypes.object,
        location: PropTypes.object,
        settings: PropTypes.object,
        urlParams: PropTypes.object,
        dispatch: PropTypes.func,
        router: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.state = {
            claimListResult: null,
            memberIdFilter: "",
            controllerNoFilter: "",
            dateFilter: "",
            patientNameFilter: "",
            loading: false,
            error: null,
            currentPage: 1,
            hasNextPage: false,
            pageSize: 100,
            activeTab: "patients",
            sortKey: null,
            sortDirection: null,
        };
    }

    componentDidMount() {
        this.fetchClaimData(1);
    }

    handleNextPage = () => {
        if (this.state.hasNextPage) {
            this.fetchClaimData(this.state.currentPage + 1);
        }
    };

    handlePrevPage = () => {
        if (this.state.currentPage > 1) {
            this.fetchClaimData(this.state.currentPage - 1);
        }
    };

    handlePageSizeChange = (e) => {
        const pageSize = parseInt(e.target.value);
        this.setState({ pageSize }, () => {
            this.fetchClaimData(1);
        });
    };

    fetchClaimData = async (page = 1) => {
        try {
            this.setState({ loading: true, error: null });

            let apiUrl = `${this.props.settings.server.url}/recycledlead?page=${page}&size=${this.state.pageSize}`;

            if (this.state.memberIdFilter) {
                apiUrl += `&memberid=${encodeURIComponent(this.state.memberIdFilter)}`;
            }
            if (this.state.dateFilter) {
                apiUrl += `&date=${encodeURIComponent(this.state.dateFilter)}`;
            }
            if (this.state.patientNameFilter) {
                apiUrl += `&membername=${encodeURIComponent(this.state.patientNameFilter)}`;
            }

            const data = await getViewPatientData({
                url: apiUrl,
                server: this.props.settings.server
            });

            const records = data?.claims || [];
            const hasNextPage = records.length === this.state.pageSize;

            console.log("Fetched records:", records);

            this.setState({
                claimListResult: records,
                loading: false,
                currentPage: page,
                hasNextPage
            });
        } catch (error) {
            console.error("Search failed:", error);
            this.setState({ error: error.message, loading: false });
        }
    };

    render() {
        if (
            this.props.location.search.includes("?_tab=demographics") ||
            this.props.location.search.includes("?_tab=conditions") ||
            this.props.location.search.includes("?_tab=tags")
        ) {
            const searchParams = new URLSearchParams(this.props.location.search);
            searchParams.delete("_resource");
            const cleanSearch = searchParams.toString() ? `?${searchParams.toString()}` : '';

            this.props.router.navigate(`/patient-list${cleanSearch}`);
            return null;
        }

        return (
            this.renderPatientsContent?.() || null
        )
    }

    renderRows(rows = []) {
        const claimListResult = rows;

        if (!claimListResult || claimListResult.length === 0) {
            return (
                <tr>
                    <td colSpan="10" className="text-center">No records found</td>
                </tr>
            );
        }

        return claimListResult.map((item, index) => (
            <tr
                key={item.MemberNumber || index}
            >
                <td className="text-center">{item.Member_CIN || "-"}</td>
                <td className="text-left">{item.Lead_Name || "-"}</td>
                <td className="text-center">
                    {item.Closed_Date ? formatDate(item.Closed_Date) : "-"}
                </td>

            </tr>
        ));
    }

    handleSort = (key) => {
        this.setState((prevState) => {
            if (prevState.sortKey !== key) {
                return { sortKey: key, sortDirection: "asc" };
            }

            if (prevState.sortDirection === "asc") {
                return { sortKey: key, sortDirection: "desc" };
            }

            return { sortKey: null, sortDirection: null };
        });
    };

    getSortIconClass = (key) => {
        const { sortKey, sortDirection } = this.state;

        if (sortKey !== key || !sortDirection) {
            return "fa-sort text-muted";
        }

        return sortDirection === "asc" ? "fa-sort-up" : "fa-sort-down";
    };

    getSortedClaims = () => {
        const { claimListResult, sortKey, sortDirection } = this.state;

        if (!claimListResult) return [];
        if (!sortKey || !sortDirection) return claimListResult;

        const sorted = [...claimListResult].sort((a, b) => {
            const aValue = a?.[sortKey];
            const bValue = b?.[sortKey];

            if (sortKey === "Closed_Date") {
                const aDate = aValue ? new Date(aValue).getTime() : 0;
                const bDate = bValue ? new Date(bValue).getTime() : 0;
                return aDate - bDate;
            }

            const aString = (aValue ?? "").toString().toLowerCase();
            const bString = (bValue ?? "").toString().toLowerCase();
            return aString.localeCompare(bString);
        });

        return sortDirection === "desc" ? sorted.reverse() : sorted;
    };


    renderPatientsContent() {
        const { loading, error, claimListResult, currentPage, hasNextPage, pageSize } = this.state;
        const sortedClaims = this.getSortedClaims();

        if (loading) {
            return <div className="patient-search-loading">
                <i className="fa fa-spinner spin" /> Loading. Please wait...
            </div>;
        }

        if (error) {
            return <p className="text-danger">Error: {error}</p>;
        }

        const searchHeader = (
            <div className="panel-default">
                <div className="panel-heading" style={{ padding: "5px 15px" }}>
                    <div className="row d-flex align-items-center">
                        <div className="col-xs-4">
                            <b className="text-primary">
                                <i className="fa fa-address-card-o" /> Recycled Leads
                            </b>
                        </div>
                        <div className="col-xs-8">
                            <div className="row">
                                <div className="col-md-3">
                                </div>
                                <div className="col-md-3">
                                    <input
                                        type="text"
                                        className="form-control input-sm"
                                        placeholder="Search by Member CIN..."
                                        value={this.state.memberIdFilter}
                                        onChange={(e) => this.setState({ memberIdFilter: e.target.value })}
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter') {
                                                this.fetchClaimData(1);
                                            }
                                        }}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <input
                                        type="date"
                                        className="form-control input-sm"
                                        placeholder="Search by Date..."
                                        value={this.state.dateFilter}
                                        onChange={(e) => this.setState({ dateFilter: e.target.value })}
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter') {
                                                this.fetchClaimData(1);
                                            }
                                        }}
                                    />
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control input-sm"
                                            placeholder="Search by Lead Name..."
                                            value={this.state.patientNameFilter}
                                            onChange={(e) => this.setState({ patientNameFilter: e.target.value })}
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter') {
                                                    this.fetchClaimData(1);
                                                }
                                            }}
                                        />
                                        <span className="input-group-btn">
                                            <button
                                                className="btn btn-primary btn-sm"
                                                onClick={() => this.fetchClaimData(1)}
                                            >
                                                <i className="fa fa-search" />
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        if (!claimListResult || claimListResult.length === 0) {
            return (
                <>
                    {searchHeader}
                    <p>No patient data available.</p>
                </>
            );
        }

        const hasPrev = currentPage > 1;
        const hasNext = hasNextPage;

        return (
            <>
                <div className="tab-content-wrapper" style={{ marginBottom: "2.5rem" }}>
                    {searchHeader}
                    <div className="panel-default">

                        <div className="table-responsive">
                            <table className="table table-condensed table-hover table-striped table-bordered">
                                <thead>
                                    <tr>
                                        {this.tableColumns.map((column) => (
                                            <th
                                                key={column.key}
                                                className={column.className || "text-center"}
                                                style={column.style || {}}
                                            >
                                                <button
                                                    type="button"
                                                    onClick={() => this.handleSort(column.key)}
                                                    style={{
                                                        border: "none",
                                                        background: "transparent",
                                                        padding: 0,
                                                        fontWeight: 600,
                                                        cursor: "pointer"
                                                    }}
                                                >
                                                    {column.label}{" "}
                                                    <i className={`fa ${this.getSortIconClass(column.key)}`} />
                                                </button>
                                            </th>
                                        ))}

                                    </tr>
                                </thead>
                                <tbody>
                                    {this.renderRows(sortedClaims)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* Footer with Pagination */}
                <div className="app-footer" style={{ position: "fixed", bottom: 0, width: "100%", backgroundColor: "#f5f5f5", borderTop: "1px solid #ddd" }}>
                    <div className="container-fluid" style={{ width: "100%" }}>
                        <div className="row">
                            <div className="col-xs-3 col-sm-4 text-right">
                                <a
                                    href="#prev"
                                    onClick={e => {
                                        e.preventDefault();
                                        if (hasPrev) this.handlePrevPage();
                                    }}
                                    style={{
                                        color: hasPrev ? '#007bff' : '#6c757d',
                                        cursor: hasPrev ? 'pointer' : 'not-allowed',
                                        textDecoration: 'none'
                                    }}
                                >
                                    <i className="fa fa-arrow-left" /> Prev
                                </a>
                            </div>
                            <div className="col-xs-6 col-sm-4 text-center">
                                <span className="pagination-status">
                                    Page {currentPage}
                                </span>
                            </div>
                            <div className="col-xs-3 col-sm-4 text-left">
                                <a
                                    href="#next"
                                    onClick={e => {
                                        e.preventDefault();
                                        if (hasNext) this.handleNextPage();
                                    }}
                                    style={{
                                        color: hasNext ? '#007bff' : '#6c757d',
                                        cursor: hasNext ? 'pointer' : 'not-allowed',
                                        textDecoration: 'none'
                                    }}
                                >
                                    Next <i className="fa fa-arrow-right" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default connect(state => state)(withRouter(RecycledLeadTab));
